import styled from 'styled-components'
import AppButton from 'Components/AppButton'
import {
  OUTLINE_COLOR,
  FONT_BASE_COLOR,
  PRIMARY_SECONDARY_COLOR,
  PRIMARY_DARK_COLOR,
  GREY_BACKGROUND,
  TEXT_GREY_DARK,
} from '@CSSVars/colors'

export const _FavouritesSectionContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 12px 0;
  border-top: 1px solid ${OUTLINE_COLOR};
  justify-content: space-between;
  align-items: start;
  
`
export const _SectionContainer = styled.div`
  display: grid;
  gap: 15px;
`
export const _NoteContainer = styled.div`
  width: 100%;
  font-size: 14px;
  line-height: 22px;
  font-family: var(--secondary-font);
  color: ${TEXT_GREY_DARK};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`

export const _TagsContainer = styled.div`
  width: 100%;
`

export const _EditButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0;
  margin-left: 15px;
  min-width: 70px;
  font-size: 14px;
  color: ${PRIMARY_DARK_COLOR};
  &:hover {
    cursor: pointer;
  }
  svg {
    margin-right: 10px;
    .st0 {
      stroke: ${PRIMARY_DARK_COLOR};
      fill: none;
    }
  }
`

export const _AddFavouritesBtn = styled(AppButton)`
  width: 100%;
  background: white;
  border: 1px solid ${OUTLINE_COLOR};
  border-radius: 10px;
  height: 44px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  color: ${PRIMARY_DARK_COLOR};

  &:active {
    background-color: ${GREY_BACKGROUND};
  }
`

export const _FavouriteTag = styled.div`
  position: relative;
  border-radius: 6px !important;
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  word-wrap: break-word;
  display: inline-block;
  background-color: ${PRIMARY_DARK_COLOR}1A;
  color: ${FONT_BASE_COLOR};
  margin-right: .6em;
  margin-bottom: .6em;
  padding: 6px 10px;
  text-decoration: none;
  transition: all .3s;
  border: none;

  ${({ active }) => (active && `
    color: white;
    background-color: ${PRIMARY_SECONDARY_COLOR};
  `)}
  @media screen and (min-width: 63.9em) {
    &:hover {
      color: ${PRIMARY_SECONDARY_COLOR};
      background-color: ${PRIMARY_DARK_COLOR}1A;
    }
  }
`
